import { Injectable } from '@angular/core';

import { CountSystem } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CountSystemService extends TmsWebBaseEditService<CountSystem, CountSystem> {
  constructor() {
    super('CountSystem', $localize`Count System`);
  }
}
